$(document).on("as_complete", document, function (e, d) {
  if ($(".change-log__item").length > 50) {
    $("#loadChangeLog").show();
  }
});

$("#loadChangeLog").click(function (evt) {
  evt.preventDefault();
  const offset = $(".change-log__item").length;
  $.ajax({
    method: "POST",
    url: "/ajax/loadbkchangelog",
    data: { offset: offset },
  }).done(function (res) {
    if (res) {
      $(".change-log").append(res);
    } else {
      $("#loadChangeLog").hide();
    }
  });
});
